import React, { useContext, useEffect, useState } from "react";
import "./Footer.css";
import { Form, InputGroup, Nav, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faGoogle,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import White_Btn from "../common_components/common_btn/white_btn/White_Btn";
import Inquiry_Form_Modal from "../common_components/inquiry_form_modal/Inquiry_Form_Modal";
import Filter_By_Offcanvas from "../common_components/filter_by_offcanvas/Filter_By_Offcanvas";
import Newsletter_offcanvas from "../common_components/newsletter_offcanvas/Newsletter_offcanvas";
import { Website_Type } from "../../utils/common";
import { occasion } from "../../utils/apis/Home/Homeapi";
import { Context } from "../../utils/context";
import { SocialMedia } from "../../utils/apis/master/Master";
const LuxuryFooter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showNewsletterOffcanvas, setShowNewsletterOffcanvas] = useState(false);
  const [showLinks, setShowLinks] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showOccasion, setShowOccasion] = useState(false);

  const socialIcons = [
    {
      icon: faFacebookF,
      link: "https://www.facebook.com/mittalcraftworks?mibextid=ZbWKwL",
    },
    { icon: faInstagram, link: "https://www.instagram.com/mittalcraftworks/" },
    { icon: faYoutube, link: "https://www.youtube.com/" },
    { icon: faXTwitter, link: "https://x.com/MittalCraftwork/" },
    {
      icon: faLinkedinIn,
      link: "https://www.linkedin.com/company/coinzkart/",
    },
  ];

  const handleNavClick = (path) => {
    if (location.pathname === path) {
      // Same page → scroll to top
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Different page → navigate normally
      navigate(path);
    }
  };

  const currentYear = new Date().getFullYear();

  const company_links = [
    {
      path: "Events",
      link: "/luxury/events",
    },
    {
      path: "Insights",
      link: "/luxury/articles",
    },
    {
      path: "About Us",
      link: "/luxury/about-us",
    },
    {
      path: "Latest News",
      link: "/luxury/latest-news",
    },
    {
      path: "Legal Notice",
      link: "/luxury/legal-notice",
    },
    {
      path: "Privacy Policy",
      link: "/luxury/privacy-policy",
    },
    {
      path: "Responsibility",
      link: "/luxury/responsibility",
    },
  ];

  const OFFERINGS = [
    { path: "Products", link: "/luxury/all-products" },
    { path: "Gift By Price", link: "" },
    { path: "Best Sellers", link: `/luxury/all-products?heading=Best Sellers` },
    { path: "Gift By Occasions", link: "/luxury/gift-by-occasions" },
    { path: "Gift Customisation", link: "/luxury/gift-customisation" },
    // { path: "Product Customisation", link: "/luxury/product-customisation" },
  ];

  const [occasions, setOcassion] = useState([]);

  const getOcassion = async () => {
    const res = await occasion(Website_Type.Luxury);
    if (res?.success) {
      setOcassion(res?.data);
    }
  };

  useEffect(() => {
    getOcassion();
  }, []);

  const POPULAR_LINKS = [
    {
      path: "For Her",
      link: `/luxury/products?gender_id=${2}&name=${"For Her"}`,
    },
    {
      path: "For Him",
      link: `/luxury/products?gender_id=${1}&name=${"For Him"}`,
    },
    {
      path: "For Baby",
      link: `/luxury/products?gender_id=${3}&name=${"For Baby"}`,
    },
    // { path: "Birthdays", link: "/luxury/home" },
    // { path: "Anniversaries", link: "/luxury/home" },
    // { path: "Wedding Gifts", link: "/luxury/home" },
    // { path: "Festive Gifting", link: "/luxury/home" },
    // { path: "BeSpoke Gifting", link: "/luxury/bespock-gift" },
  ];

  const SUPPORT_LINKS = [
    { path: "Help", link: "/luxury/help" },
    { path: "FAQ", link: "/luxury/faq" },
    { path: "Deliveries", link: "/luxury/deliveries" },
    { path: "Contact Us", link: "/luxury/contact-us" },
    { path: "Suggestions", link: "/luxury/suggestions" },
    { path: "Unsubscribe", link: "/luxury/unsubscribe" },
    { path: "Product Care", link: "/luxury/product-care" },
    { path: "Terms & Conditions", link: "/luxury/terms-conditions" },
  ];

  const [data, setData] = useState();
  const { IMG_URL, signin } = useContext(Context);
  const [showSuccess, setShowsuccess] = useState(false);
  const getAllData = async () => {
    const res = await SocialMedia();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData();
  }, []);

  return (
    <section className="LuxuryFooter">
      <div className="custom_container">
        <div className="row">
          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6 mt-3  mb-4">
            <div className="links-sec">
              <div
                className="link_heading_div"
                onClick={() => {
                  setShowLinks(!showLinks);
                }}
              >
                <h3 className="section_heading top">THE COMPANY</h3>
                <div className="icon_holder">
                  {!showLinks ? (
                    <img
                      src="/assest/luxury_images/other/down.png"
                      className="inner_img"
                    />
                  ) : (
                    <img
                      src="/assest/luxury_images/other/up.png"
                      className="inner_img"
                    />
                  )}
                </div>
              </div>

              <div className={`all_links_holder${showLinks ? " active" : ""}`}>
                {company_links?.map((item) => {
                  return (
                    <NavLink as={Link} to={item?.link}>
                      {item?.path}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6 mt-3  mb-4">
            <div className="links-sec">
              <div
                className="link_heading_div"
                onClick={() => {
                  setShowLinks(!showLinks);
                }}
              >
                <h3 className="section_heading top">OFFERINGS</h3>
                <div className="icon_holder">
                  {!showLinks ? (
                    <img
                      src="/assest/luxury_images/other/down.png"
                      className="inner_img"
                    />
                  ) : (
                    <img
                      src="/assest/luxury_images/other/up.png"
                      className="inner_img"
                    />
                  )}
                </div>
              </div>

              <div className={`all_links_holder${showLinks ? " active" : ""}`}>
                {OFFERINGS?.map((item) => {
                  return (
                    <NavLink
                      as={item.link ? Link : "span"}
                      to={item?.link}
                      onClick={() => {
                        if (item?.path === "Gift By Price") {
                          setShowFilter(true);
                        }
                        if (item?.path === "Gift By Occasions") {
                          setShowFilter(true);
                          setShowOccasion(true);
                        }
                      }}
                    >
                      {item?.path}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6 mt-3  mb-4">
            <div className="links-sec">
              <div
                className="link_heading_div"
                onClick={() => {
                  setShowLinks(!showLinks);
                }}
              >
                <h3 className="section_heading top">POPULAR LINKS</h3>
                <div className="icon_holder">
                  {!showLinks ? (
                    <img
                      src="/assest/luxury_images/other/down.png"
                      className="inner_img"
                    />
                  ) : (
                    <img
                      src="/assest/luxury_images/other/up.png"
                      className="inner_img"
                    />
                  )}
                </div>
              </div>

              <div className={`all_links_holder${showLinks ? " active" : ""}`}>
                {POPULAR_LINKS?.map((item) => {
                  return (
                    <NavLink as={Link} to={item?.link}>
                      {item?.path}
                    </NavLink>
                  );
                })}
                {occasions
                  ?.slice() // clone array (important)
                  ?.sort((a, b) => a.name.length - b.name.length)
                  ?.slice(0, 5)
                  ?.map((item) => (
                    <NavLink
                      key={item.id}
                      as={Link}
                      to={`/luxury/products?occasion_id=${item?.id}&name=${item?.name}`}
                    >
                      {item?.name}
                    </NavLink>
                  ))}
                <NavLink as={Link} to={`/luxury/gift-by-occasions`}>
                  Festive Gifting
                </NavLink>
                <NavLink as={Link} to={`/luxury/bespock-gift`}>
                  Bespoke Gifting
                </NavLink>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6 mt-3  mb-4">
            <div className="links-sec">
              <div
                className="link_heading_div"
                onClick={() => {
                  setShowLinks(!showLinks);
                }}
              >
                <h3 className="section_heading top">SUPPORT</h3>
                <div className="icon_holder">
                  {!showLinks ? (
                    <img
                      src="/assest/luxury_images/other/down.png"
                      className="inner_img"
                    />
                  ) : (
                    <img
                      src="/assest/luxury_images/other/up.png"
                      className="inner_img"
                    />
                  )}
                </div>
              </div>

              <div className={`all_links_holder${showLinks ? " active" : ""}`}>
                {SUPPORT_LINKS?.map((item) => {
                  return (
                    <NavLink as={Link} to={item?.link}>
                      {item?.path}
                    </NavLink>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="divider"></div>

      <div className="top_footer">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-4 col-sm-7  mb-3">
              <div className="inner_col_div">
                <div className="col_div">
                  <p className="section_heading">CUSTOMER SERVICE</p>

                  <p className="simple_text">
                    Monday to Saturday 10:00 am - 06:00 pm IST,
                  </p>

                  <p className="link_text">+91 731 6711 800</p>
                  <p className="link_text">+91 93029 11233</p>

                  <div className="email_div">
                    <p className="simple_text">Email us:</p>
                    <p className="link_text">sales@mittalcraftworks.com</p>
                  </div>

                  <p className="simple_text">Corporate Office:</p>
                  <p className="simple_text">
                    304, Apollo Trade Centre, A. B. Road, Indore, Madhya
                    Pradesh, 452 001, India, Bharat
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-5  mb-3">
              <div className="inner_col_div">
                <div className="col_div newsletter">
                  <p className="section_heading">NEWSLETTER</p>

                  <p className="simple_text">
                    Receive our newsletter and discover our stories, collections
                    and surprises.
                  </p>

                  <div className="btn_holder">
                    <White_Btn
                      btnText={"Subscribe"}
                      onClick={() => {
                        setShowNewsletterOffcanvas(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 ">
              <div className="inner_col_div">
                <div className="col_div">
                  <p className="section_heading">FOLLOW US</p>

                  <div className="icons_holder">
                    {/* {data?.map((val) => (
                      <div className="social-icon text-center">
                        <a
                          href={val?.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            className="x-logo"
                            src={`${IMG_URL}${val?.image}`}
                            alt="Logo"
                          />
                        </a>
                      </div>
                    ))} */}
                    {data?.map((item, index) => (
                      <div className="icon_holder">
                        <a
                          key={index}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          <img
                            className="x-logo"
                            src={`${IMG_URL}${item?.image}`}
                            alt="Logo"
                          />
                          {/* <FontAwesomeIcon
                            icon={item?.icon}
                            className="icon_class"
                          /> */}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom_footer">
        <div className="custom_container">
          <div className="bottom_holder">
            <div className="footer_text_div">
              <p className="footer_text">
                Copyright © {currentYear} Mittal Craftworks.
              </p>
            </div>

            <p className="bottom_text">
              All rights reserved. Use of this website indicates your compliance
              with our{" "}
              <span onClick={() => navigate("/luxury/privacy-policy")}>
                {" "}
                <b>Privacy Policy</b>{" "}
              </span>
              , Conditions of Carriage,{" "}
              <span onClick={() => navigate("/luxury/terms-conditions")}>
                {" "}
                <b> Terms and Conditions </b>{" "}
              </span>{" "}
              .
            </p>
          </div>
        </div>
      </div>

      <Filter_By_Offcanvas
        showOccasion={showOccasion}
        show={showFilter}
        handleClose={() => setShowFilter(false)}
      />

      <Inquiry_Form_Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <Newsletter_offcanvas
        show={showNewsletterOffcanvas}
        handleClose={() => setShowNewsletterOffcanvas(false)}
      />
    </section>
  );
};

export default LuxuryFooter;
